/**
 * This code was AUTOGENERATED using the codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  addDecoderSizePrefix,
  addEncoderSizePrefix,
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getBooleanDecoder,
  getBooleanEncoder,
  getBytesDecoder,
  getBytesEncoder,
  getDiscriminatedUnionDecoder,
  getDiscriminatedUnionEncoder,
  getI128Decoder,
  getI128Encoder,
  getI16Decoder,
  getI16Encoder,
  getI32Decoder,
  getI32Encoder,
  getI64Decoder,
  getI64Encoder,
  getI8Decoder,
  getI8Encoder,
  getOptionDecoder,
  getOptionEncoder,
  getStructDecoder,
  getStructEncoder,
  getTupleDecoder,
  getTupleEncoder,
  getU128Decoder,
  getU128Encoder,
  getU16Decoder,
  getU16Encoder,
  getU32Decoder,
  getU32Encoder,
  getU64Decoder,
  getU64Encoder,
  getU8Decoder,
  getU8Encoder,
  type Address,
  type Codec,
  type Decoder,
  type Encoder,
  type GetDiscriminatedUnionVariant,
  type GetDiscriminatedUnionVariantContent,
  type Option,
  type OptionOrNullable,
  type ReadonlyUint8Array,
} from '@solana/kit';

export type AssertionResult =
  | {
      __kind: 'U8';
      fields: readonly [Option<number>, Option<number>, number, boolean];
    }
  | {
      __kind: 'U16';
      fields: readonly [Option<number>, Option<number>, number, boolean];
    }
  | {
      __kind: 'U32';
      fields: readonly [Option<number>, Option<number>, number, boolean];
    }
  | {
      __kind: 'U64';
      fields: readonly [Option<bigint>, Option<bigint>, number, boolean];
    }
  | {
      __kind: 'U128';
      fields: readonly [Option<bigint>, Option<bigint>, number, boolean];
    }
  | {
      __kind: 'I8';
      fields: readonly [Option<number>, Option<number>, number, boolean];
    }
  | {
      __kind: 'I16';
      fields: readonly [Option<number>, Option<number>, number, boolean];
    }
  | {
      __kind: 'I32';
      fields: readonly [Option<number>, Option<number>, number, boolean];
    }
  | {
      __kind: 'I64';
      fields: readonly [Option<bigint>, Option<bigint>, number, boolean];
    }
  | {
      __kind: 'I128';
      fields: readonly [Option<bigint>, Option<bigint>, number, boolean];
    }
  | {
      __kind: 'Pubkey';
      fields: readonly [Option<Address>, Option<Address>, number, boolean];
    }
  | {
      __kind: 'Bytes';
      fields: readonly [
        ReadonlyUint8Array,
        ReadonlyUint8Array,
        number,
        boolean,
      ];
    }
  | {
      __kind: 'Bool';
      fields: readonly [Option<boolean>, Option<boolean>, number, boolean];
    };

export type AssertionResultArgs =
  | {
      __kind: 'U8';
      fields: readonly [
        OptionOrNullable<number>,
        OptionOrNullable<number>,
        number,
        boolean,
      ];
    }
  | {
      __kind: 'U16';
      fields: readonly [
        OptionOrNullable<number>,
        OptionOrNullable<number>,
        number,
        boolean,
      ];
    }
  | {
      __kind: 'U32';
      fields: readonly [
        OptionOrNullable<number>,
        OptionOrNullable<number>,
        number,
        boolean,
      ];
    }
  | {
      __kind: 'U64';
      fields: readonly [
        OptionOrNullable<number | bigint>,
        OptionOrNullable<number | bigint>,
        number,
        boolean,
      ];
    }
  | {
      __kind: 'U128';
      fields: readonly [
        OptionOrNullable<number | bigint>,
        OptionOrNullable<number | bigint>,
        number,
        boolean,
      ];
    }
  | {
      __kind: 'I8';
      fields: readonly [
        OptionOrNullable<number>,
        OptionOrNullable<number>,
        number,
        boolean,
      ];
    }
  | {
      __kind: 'I16';
      fields: readonly [
        OptionOrNullable<number>,
        OptionOrNullable<number>,
        number,
        boolean,
      ];
    }
  | {
      __kind: 'I32';
      fields: readonly [
        OptionOrNullable<number>,
        OptionOrNullable<number>,
        number,
        boolean,
      ];
    }
  | {
      __kind: 'I64';
      fields: readonly [
        OptionOrNullable<number | bigint>,
        OptionOrNullable<number | bigint>,
        number,
        boolean,
      ];
    }
  | {
      __kind: 'I128';
      fields: readonly [
        OptionOrNullable<number | bigint>,
        OptionOrNullable<number | bigint>,
        number,
        boolean,
      ];
    }
  | {
      __kind: 'Pubkey';
      fields: readonly [
        OptionOrNullable<Address>,
        OptionOrNullable<Address>,
        number,
        boolean,
      ];
    }
  | {
      __kind: 'Bytes';
      fields: readonly [
        ReadonlyUint8Array,
        ReadonlyUint8Array,
        number,
        boolean,
      ];
    }
  | {
      __kind: 'Bool';
      fields: readonly [
        OptionOrNullable<boolean>,
        OptionOrNullable<boolean>,
        number,
        boolean,
      ];
    };

export function getAssertionResultEncoder(): Encoder<AssertionResultArgs> {
  return getDiscriminatedUnionEncoder([
    [
      'U8',
      getStructEncoder([
        [
          'fields',
          getTupleEncoder([
            getOptionEncoder(getU8Encoder()),
            getOptionEncoder(getU8Encoder()),
            getU8Encoder(),
            getBooleanEncoder(),
          ]),
        ],
      ]),
    ],
    [
      'U16',
      getStructEncoder([
        [
          'fields',
          getTupleEncoder([
            getOptionEncoder(getU16Encoder()),
            getOptionEncoder(getU16Encoder()),
            getU8Encoder(),
            getBooleanEncoder(),
          ]),
        ],
      ]),
    ],
    [
      'U32',
      getStructEncoder([
        [
          'fields',
          getTupleEncoder([
            getOptionEncoder(getU32Encoder()),
            getOptionEncoder(getU32Encoder()),
            getU8Encoder(),
            getBooleanEncoder(),
          ]),
        ],
      ]),
    ],
    [
      'U64',
      getStructEncoder([
        [
          'fields',
          getTupleEncoder([
            getOptionEncoder(getU64Encoder()),
            getOptionEncoder(getU64Encoder()),
            getU8Encoder(),
            getBooleanEncoder(),
          ]),
        ],
      ]),
    ],
    [
      'U128',
      getStructEncoder([
        [
          'fields',
          getTupleEncoder([
            getOptionEncoder(getU128Encoder()),
            getOptionEncoder(getU128Encoder()),
            getU8Encoder(),
            getBooleanEncoder(),
          ]),
        ],
      ]),
    ],
    [
      'I8',
      getStructEncoder([
        [
          'fields',
          getTupleEncoder([
            getOptionEncoder(getI8Encoder()),
            getOptionEncoder(getI8Encoder()),
            getU8Encoder(),
            getBooleanEncoder(),
          ]),
        ],
      ]),
    ],
    [
      'I16',
      getStructEncoder([
        [
          'fields',
          getTupleEncoder([
            getOptionEncoder(getI16Encoder()),
            getOptionEncoder(getI16Encoder()),
            getU8Encoder(),
            getBooleanEncoder(),
          ]),
        ],
      ]),
    ],
    [
      'I32',
      getStructEncoder([
        [
          'fields',
          getTupleEncoder([
            getOptionEncoder(getI32Encoder()),
            getOptionEncoder(getI32Encoder()),
            getU8Encoder(),
            getBooleanEncoder(),
          ]),
        ],
      ]),
    ],
    [
      'I64',
      getStructEncoder([
        [
          'fields',
          getTupleEncoder([
            getOptionEncoder(getI64Encoder()),
            getOptionEncoder(getI64Encoder()),
            getU8Encoder(),
            getBooleanEncoder(),
          ]),
        ],
      ]),
    ],
    [
      'I128',
      getStructEncoder([
        [
          'fields',
          getTupleEncoder([
            getOptionEncoder(getI128Encoder()),
            getOptionEncoder(getI128Encoder()),
            getU8Encoder(),
            getBooleanEncoder(),
          ]),
        ],
      ]),
    ],
    [
      'Pubkey',
      getStructEncoder([
        [
          'fields',
          getTupleEncoder([
            getOptionEncoder(getAddressEncoder()),
            getOptionEncoder(getAddressEncoder()),
            getU8Encoder(),
            getBooleanEncoder(),
          ]),
        ],
      ]),
    ],
    [
      'Bytes',
      getStructEncoder([
        [
          'fields',
          getTupleEncoder([
            addEncoderSizePrefix(getBytesEncoder(), getU32Encoder()),
            addEncoderSizePrefix(getBytesEncoder(), getU32Encoder()),
            getU8Encoder(),
            getBooleanEncoder(),
          ]),
        ],
      ]),
    ],
    [
      'Bool',
      getStructEncoder([
        [
          'fields',
          getTupleEncoder([
            getOptionEncoder(getBooleanEncoder()),
            getOptionEncoder(getBooleanEncoder()),
            getU8Encoder(),
            getBooleanEncoder(),
          ]),
        ],
      ]),
    ],
  ]);
}

export function getAssertionResultDecoder(): Decoder<AssertionResult> {
  return getDiscriminatedUnionDecoder([
    [
      'U8',
      getStructDecoder([
        [
          'fields',
          getTupleDecoder([
            getOptionDecoder(getU8Decoder()),
            getOptionDecoder(getU8Decoder()),
            getU8Decoder(),
            getBooleanDecoder(),
          ]),
        ],
      ]),
    ],
    [
      'U16',
      getStructDecoder([
        [
          'fields',
          getTupleDecoder([
            getOptionDecoder(getU16Decoder()),
            getOptionDecoder(getU16Decoder()),
            getU8Decoder(),
            getBooleanDecoder(),
          ]),
        ],
      ]),
    ],
    [
      'U32',
      getStructDecoder([
        [
          'fields',
          getTupleDecoder([
            getOptionDecoder(getU32Decoder()),
            getOptionDecoder(getU32Decoder()),
            getU8Decoder(),
            getBooleanDecoder(),
          ]),
        ],
      ]),
    ],
    [
      'U64',
      getStructDecoder([
        [
          'fields',
          getTupleDecoder([
            getOptionDecoder(getU64Decoder()),
            getOptionDecoder(getU64Decoder()),
            getU8Decoder(),
            getBooleanDecoder(),
          ]),
        ],
      ]),
    ],
    [
      'U128',
      getStructDecoder([
        [
          'fields',
          getTupleDecoder([
            getOptionDecoder(getU128Decoder()),
            getOptionDecoder(getU128Decoder()),
            getU8Decoder(),
            getBooleanDecoder(),
          ]),
        ],
      ]),
    ],
    [
      'I8',
      getStructDecoder([
        [
          'fields',
          getTupleDecoder([
            getOptionDecoder(getI8Decoder()),
            getOptionDecoder(getI8Decoder()),
            getU8Decoder(),
            getBooleanDecoder(),
          ]),
        ],
      ]),
    ],
    [
      'I16',
      getStructDecoder([
        [
          'fields',
          getTupleDecoder([
            getOptionDecoder(getI16Decoder()),
            getOptionDecoder(getI16Decoder()),
            getU8Decoder(),
            getBooleanDecoder(),
          ]),
        ],
      ]),
    ],
    [
      'I32',
      getStructDecoder([
        [
          'fields',
          getTupleDecoder([
            getOptionDecoder(getI32Decoder()),
            getOptionDecoder(getI32Decoder()),
            getU8Decoder(),
            getBooleanDecoder(),
          ]),
        ],
      ]),
    ],
    [
      'I64',
      getStructDecoder([
        [
          'fields',
          getTupleDecoder([
            getOptionDecoder(getI64Decoder()),
            getOptionDecoder(getI64Decoder()),
            getU8Decoder(),
            getBooleanDecoder(),
          ]),
        ],
      ]),
    ],
    [
      'I128',
      getStructDecoder([
        [
          'fields',
          getTupleDecoder([
            getOptionDecoder(getI128Decoder()),
            getOptionDecoder(getI128Decoder()),
            getU8Decoder(),
            getBooleanDecoder(),
          ]),
        ],
      ]),
    ],
    [
      'Pubkey',
      getStructDecoder([
        [
          'fields',
          getTupleDecoder([
            getOptionDecoder(getAddressDecoder()),
            getOptionDecoder(getAddressDecoder()),
            getU8Decoder(),
            getBooleanDecoder(),
          ]),
        ],
      ]),
    ],
    [
      'Bytes',
      getStructDecoder([
        [
          'fields',
          getTupleDecoder([
            addDecoderSizePrefix(getBytesDecoder(), getU32Decoder()),
            addDecoderSizePrefix(getBytesDecoder(), getU32Decoder()),
            getU8Decoder(),
            getBooleanDecoder(),
          ]),
        ],
      ]),
    ],
    [
      'Bool',
      getStructDecoder([
        [
          'fields',
          getTupleDecoder([
            getOptionDecoder(getBooleanDecoder()),
            getOptionDecoder(getBooleanDecoder()),
            getU8Decoder(),
            getBooleanDecoder(),
          ]),
        ],
      ]),
    ],
  ]);
}

export function getAssertionResultCodec(): Codec<
  AssertionResultArgs,
  AssertionResult
> {
  return combineCodec(getAssertionResultEncoder(), getAssertionResultDecoder());
}

// Data Enum Helpers.
export function assertionResult(
  kind: 'U8',
  data: GetDiscriminatedUnionVariantContent<
    AssertionResultArgs,
    '__kind',
    'U8'
  >['fields']
): GetDiscriminatedUnionVariant<AssertionResultArgs, '__kind', 'U8'>;
export function assertionResult(
  kind: 'U16',
  data: GetDiscriminatedUnionVariantContent<
    AssertionResultArgs,
    '__kind',
    'U16'
  >['fields']
): GetDiscriminatedUnionVariant<AssertionResultArgs, '__kind', 'U16'>;
export function assertionResult(
  kind: 'U32',
  data: GetDiscriminatedUnionVariantContent<
    AssertionResultArgs,
    '__kind',
    'U32'
  >['fields']
): GetDiscriminatedUnionVariant<AssertionResultArgs, '__kind', 'U32'>;
export function assertionResult(
  kind: 'U64',
  data: GetDiscriminatedUnionVariantContent<
    AssertionResultArgs,
    '__kind',
    'U64'
  >['fields']
): GetDiscriminatedUnionVariant<AssertionResultArgs, '__kind', 'U64'>;
export function assertionResult(
  kind: 'U128',
  data: GetDiscriminatedUnionVariantContent<
    AssertionResultArgs,
    '__kind',
    'U128'
  >['fields']
): GetDiscriminatedUnionVariant<AssertionResultArgs, '__kind', 'U128'>;
export function assertionResult(
  kind: 'I8',
  data: GetDiscriminatedUnionVariantContent<
    AssertionResultArgs,
    '__kind',
    'I8'
  >['fields']
): GetDiscriminatedUnionVariant<AssertionResultArgs, '__kind', 'I8'>;
export function assertionResult(
  kind: 'I16',
  data: GetDiscriminatedUnionVariantContent<
    AssertionResultArgs,
    '__kind',
    'I16'
  >['fields']
): GetDiscriminatedUnionVariant<AssertionResultArgs, '__kind', 'I16'>;
export function assertionResult(
  kind: 'I32',
  data: GetDiscriminatedUnionVariantContent<
    AssertionResultArgs,
    '__kind',
    'I32'
  >['fields']
): GetDiscriminatedUnionVariant<AssertionResultArgs, '__kind', 'I32'>;
export function assertionResult(
  kind: 'I64',
  data: GetDiscriminatedUnionVariantContent<
    AssertionResultArgs,
    '__kind',
    'I64'
  >['fields']
): GetDiscriminatedUnionVariant<AssertionResultArgs, '__kind', 'I64'>;
export function assertionResult(
  kind: 'I128',
  data: GetDiscriminatedUnionVariantContent<
    AssertionResultArgs,
    '__kind',
    'I128'
  >['fields']
): GetDiscriminatedUnionVariant<AssertionResultArgs, '__kind', 'I128'>;
export function assertionResult(
  kind: 'Pubkey',
  data: GetDiscriminatedUnionVariantContent<
    AssertionResultArgs,
    '__kind',
    'Pubkey'
  >['fields']
): GetDiscriminatedUnionVariant<AssertionResultArgs, '__kind', 'Pubkey'>;
export function assertionResult(
  kind: 'Bytes',
  data: GetDiscriminatedUnionVariantContent<
    AssertionResultArgs,
    '__kind',
    'Bytes'
  >['fields']
): GetDiscriminatedUnionVariant<AssertionResultArgs, '__kind', 'Bytes'>;
export function assertionResult(
  kind: 'Bool',
  data: GetDiscriminatedUnionVariantContent<
    AssertionResultArgs,
    '__kind',
    'Bool'
  >['fields']
): GetDiscriminatedUnionVariant<AssertionResultArgs, '__kind', 'Bool'>;
export function assertionResult<K extends AssertionResultArgs['__kind'], Data>(
  kind: K,
  data?: Data
) {
  return Array.isArray(data)
    ? { __kind: kind, fields: data }
    : { __kind: kind, ...(data ?? {}) };
}

export function isAssertionResult<K extends AssertionResult['__kind']>(
  kind: K,
  value: AssertionResult
): value is AssertionResult & { __kind: K } {
  return value.__kind === kind;
}
